var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TotemFilterResult',{attrs:{"listLength":_vm.filteredCount}}),_c('HideFilters',{attrs:{"filtersHidden":!_vm.showMoreFilters},on:{"toggleFilters":_vm.toggleShowMoreFilters}}),_c('Sorter'),(!_vm.canShowListToggleView)?_c('CourseListViewToggle'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }